export default __webpack_public_path__ + "static/media/blogs_header.099d21e0.jpg";